module.exports = __webpack_public_path__ + "img/MX.9f3f778d.webp";